export const uniqArray = <T>(array: T[]): T[] => {
  return Array.from(new Set(array));
};
